<template>
  <div class="card-container">
    <AnalyticsCard
      :title="'CHATS TODAY'"
      :leftTextTitle="'Resolved'"
      :leftTextValue="resolvedCount"
      :rightTextTitle="'Abandoned'"
      :rightTextValue="abandonedCount"
      :type="'chats'"
    />
    <AnalyticsCard
      :title="'ACTIVE AGENTS'"
      :leftTextTitle="'Engaged'"
      :leftTextValue="filteredEngagedAgents.length"
      :rightTextTitle="'Available'"
      :rightTextValue="filteredAvailableAgents.length"
      :icon="'users'"
      :type="'active-agents'"
    />
    <AnalyticsCard
      :title="'QUEUE LENGTH'"
      :leftTextTitle="'In Progress'"
      :leftTextValue="inProgressCount"
      :rightTextTitle="'In Queue'"
      :rightTextValue="inQueueCount"
      :icon="'clock'"
      :type="'queue-length'"
    />
    <AnalyticsCard
      :title="'AVG. WAIT TIME'"
      :centerTextTitle="'Current average'"
      :centerTextValue="averageWaitTime"
      :icon="'trending-up'"
      :type="'response-time'"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import AnalyticsCard from './AnalyticsCard.vue';
import { liveAnalyticsMixin } from '@/mixins/liveAnalytics';

export default {
  mixins: [liveAnalyticsMixin],
  components: {
    AnalyticsCard,
  },
  props: {
    selectedDepartments: {
      type: Array,
      default: () => [],
    },
    resolvedCount: {
      type: [String, Number],
      required: true,
    },
    inProgressCount: {
      type: [String, Number],
      required: true,
    },
    abandonedCount: {
      type: [String, Number],
      required: true,
    },
    inQueueCount: {
      type: [String, Number],
      required: true,
    },
    averageWaitTime: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    ...mapGetters(['engagedAgents', 'availableAgents']),
    filteredEngagedAgents() {
      if (!this.selectedDepartments?.length) {
        return this.engagedAgents;
      }
      return this.engagedAgents.filter((agent) =>
        this.agentMatchesDepartmentFilter(agent, this.selectedDepartments),
      );
    },
    filteredAvailableAgents() {
      if (!this.selectedDepartments?.length) {
        return this.availableAgents;
      }
      return this.availableAgents.filter((agent) =>
        this.agentMatchesDepartmentFilter(agent, this.selectedDepartments),
      );
    },
  },
  methods: {
    // Check if agent matches department filter
    agentMatchesDepartmentFilter(agent, selectedDepartments) {
      if (!selectedDepartments?.length) return true;

      const agentDepartments = this.parseAgentDepartments(agent);
      const selectedDeptNames = this.getSelectedDepartmentNames(selectedDepartments);

      return agentDepartments.some((agentDept) => {
        const agentDeptLower =
          (agentDept?.name || agentDept)?.toLowerCase?.() || '';

        return (
          selectedDepartments.includes(agentDept) ||
          selectedDepartments.includes(agentDept?.id) ||
          selectedDeptNames.includes(agentDeptLower)
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.card-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  padding: 0 1rem;

  @media only screen and (min-width: 512px) and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 512px) {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
